import { render, staticRenderFns } from "./VideoManager.vue?vue&type=template&id=0c902912&"
import script from "./VideoManager.vue?vue&type=script&lang=js&"
export * from "./VideoManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports